import React from "react";
import { Row, Container, Col } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

function Abouttekuk() {
  return (
    <section
      className="abouttek_uk p-100"
      style={{
        background: "linear-gradient(269.71deg, #FCFCFC 0.46%, #FCF8FE 99.77%)",
      }}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={5}
            xxl={5}
            className="order-md-1 order-2 mt-4 mt-md-0"
          >
            <StaticImage
              src="../../images/services-usa/hire_android/solving_android.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={594}
              height={649}
            />
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto offset-xl-1 order-md-2 order-1"
          >
            <h2>Solving Your Android App Development Challenges</h2>
            <p>
              Hiring the right Android developers can be daunting. Our skilled,
              in-house Android app development team guarantees proficient and
              reliable services designed to complement your modern{" "}
              <Link to="https://www.tekrevol.com/mobile-app-development">
                mobile application development
              </Link>{" "}
              goals. From startups to large enterprises, our developers bring
              extensive technical knowledge and creativity to every project.
            </p>
            <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Find Android App Developers
            </Link>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Abouttekuk;
